import f from "moment";
function _(e) {
  const t = `${e}=`, n = document.cookie.split(";");
  for (let a = 0; a < n.length; a += 1) {
    let o = n[a];
    for (; o.charAt(0) === " "; )
      o = o.substring(1);
    if (o.indexOf(t) === 0)
      return o.substring(t.length, o.length);
  }
  return "";
}
function h(e, t, n = new Date((/* @__PURE__ */ new Date()).getTime() + 24 * 60 * 60 * 1e3)) {
  const a = process.env.NODE_ENV !== "testing" ? window.location.hostname : "localhost";
  let o = `${e}=${t}; expires=${n.toUTCString()}; path=/; secure;`;
  process.env.NODE_ENV !== "development" && (o += ` domain=${a}`), document.cookie = o;
}
function P(e) {
  h(e, "", new Date((/* @__PURE__ */ new Date()).getTime() - 1));
}
function D(e) {
  let t;
  return e ? t = _(`${e}-auth-token`) : t = _("auth-token"), {
    headers: { "X-API-AUTHTOKEN": `${t}` }
  };
}
f.locale("us");
function A(e) {
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(e))
    return !1;
  const t = e.split("/"), n = Number(t[1]), a = Number(t[0]), o = Number(t[2]);
  if (o < 1e3 || o > 3e3 || a === 0 || a > 12)
    return !1;
  const r = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return (o % 400 === 0 || o % 100 !== 0 && o % 4 === 0) && (r[1] = 29), n > 0 && n <= r[a - 1];
}
function w(e) {
  const n = e.charAt(e.length - 1) === "Z" ? e : `${e}Z`;
  return new Date(n);
}
function $(e) {
  if (!e)
    return "";
  const t = w(e);
  return f(t).format("MM/DD/YY h:mma");
}
function N(e = "", t = "MMMM Do, YYYY") {
  if (!e)
    return "";
  const a = !f(e, "YYYY-MM-DD", !0).isValid() ? w(e) : e;
  return f(a).format(t);
}
const y = (e) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}, T = (e) => {
  if (e && typeof e == "function")
    y(e);
  else
    return new Promise((t) => {
      y(t);
    });
};
function B(e, t = "id") {
  return Object.assign({}, ...e.map((n) => ({ [n[t]]: n })));
}
function C(e) {
  const t = [];
  let n, a;
  for (let o = 0; o < e.length; o += 1) {
    for (n = e[o], a = n; e[o + 1] - e[o] === 1; )
      a = e[o + 1], o += 1;
    t.push(n === a ? `${n}` : `${n}-${a}`);
  }
  return t;
}
function x({
  amount: e,
  prepend: t = "",
  append: n = "",
  decimalCountParam: a = 2,
  showZeroes: o = !0,
  decimalParam: r = ".",
  thousands: i = ","
}) {
  try {
    const u = Math.abs(a), c = Number.isNaN(u) ? 2 : u, s = parseInt(Math.abs(Number(e) || 0).toFixed(c), 10).toString(), m = s.length > 3 ? s.length % 3 : 0, g = e < 0 ? "-" : "";
    let d = c ? r + Math.abs(e - s).toFixed(c).slice(-c) : "";
    return o || (d = d.replace(/0+$/, ""), d.length === 1 && (d = "")), g + t + (m ? s.substr(0, m) + i : "") + s.substr(m).replace(/(\d{3})(?=\d)/g, `$1${i}`) + d + n;
  } catch {
    return e;
  }
}
function M(e, t = "name", n = "asc") {
  return [...e].sort((a, o) => {
    let r = a[t], i = o[t];
    return n === "desc" && (r = o[t], i = a[t]), Number.isInteger(r) && Number.isInteger(i) ? r - i : (typeof r == "string" && typeof i == "string" && (r = r.toUpperCase(), i = i.toUpperCase()), r < i ? -1 : r > i ? 1 : 0);
  });
}
function E(e, t = "product_type_name") {
  return e[t].toLowerCase() === "stop loss";
}
function S() {
  const e = {
    initialBuild: "Projects::InitialEmployerBuild",
    coverageBuild: "Projects::CoverageBuild",
    policyAudit: "Projects::PolicyAudit",
    goToMarket: "Projects::RfpPlacementEvent",
    renewal: "Projects::RenewalPlacementEvent",
    isBuildType: (t) => [
      e.initialBuild,
      e.coverageBuild
    ].includes(t)
  };
  return e;
}
function j() {
  return [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
}
function O(e) {
  let t = null;
  switch (e) {
    case "spouse":
    case "child":
    case "core":
    case "buyup":
    case "male":
    case "female":
    case "employee":
    case "family":
      t = !0;
      break;
    case "non_smoker":
    case "smoker":
      t = !1;
      break;
  }
  return t;
}
function F(e) {
  const t = { label: "Non-Smoker/Smoker", subtypes: ["non_smoker", "smoker"] }, n = { label: "Spouse/Child", subtypes: ["spouse", "child"] }, a = { label: "Employee/Family", subtypes: ["employee", "family"] }, o = { label: "Core/Buy-Up", subtypes: ["core", "buyup"] }, r = { label: "Male/Female", subtypes: ["male", "female"] };
  return {
    "Basic Life / AD&D": [],
    "Basic Dependent Life": [n],
    "Optional Life": [a, t, r],
    "Optional AD&D": [a, t],
    "Advice To Pay": [],
    "Statutory Plan - CA,HI,NJ,PR,RI": [o, r],
    "Short Term Disability": [o, r],
    "NY DBL": [r],
    "Long Term Disability": [o]
  }[e];
}
function L(e) {
  const t = { label: "Per $10", value: 10 }, n = { label: "Per $25", value: 25 }, a = { label: "Per $50", value: 50 }, o = { label: "Per $75", value: 75 }, r = { label: "Per $100", value: 100 }, i = { label: "Per $1,000", value: 1e3 }, u = { label: "Per $2,000", value: 2e3 }, c = { label: "Per $5,000", value: 5e3 }, s = { label: "Per $10,000", value: 1e4 }, m = { label: "Per $15,000", value: 15e3 }, g = { label: "Per $20,000", value: 2e4 }, d = { label: "Per $30,000", value: 3e4 }, p = { label: "Per Unit", value: 1 }, l = { label: "Per Employee Per Month", value: 1 }, b = [
    l,
    n,
    a,
    o,
    i,
    u,
    c,
    s
  ];
  return {
    1: [t, r, l],
    // short term disability
    2: [i, l],
    // basic life/AD&D
    3: [i, p],
    // Basic Dependent Life
    4: [i, u, c, s, p],
    // Voluntary Life
    5: [i, u, c, s, p],
    // Optional AD&D
    7: [r, l],
    // Long Term Disability
    8: [l],
    // Advice To Pay
    9: [t, r, l],
    // NY DBL
    11: [t, r, l],
    // NJ TDB,
    12: [l],
    // absence management
    13: [t, r, l],
    // HI TDI
    14: [l],
    // Dental
    15: [l],
    // Vision
    16: [...b, m, g, d],
    // Critical Illness
    17: b,
    // Accident
    18: b,
    // Hospital Indemnity
    19: [l],
    // Stop Loss
    21: [i, u, c, s, p]
    // Voluntary Life / AD&D
  }[e] || [t, r, l];
}
function R() {
  return [
    "age_0_19",
    "age_20_24",
    "age_25_29",
    "age_30_34",
    "age_35_39",
    "age_40_44",
    "age_45_49",
    "age_50_54",
    "age_55_59",
    "age_60_64",
    "age_65_69",
    "age_70_74",
    "age_75_79",
    "age_80_plus"
  ];
}
function U() {
  return [
    "application/pdf",
    "application/msword",
    "application/rtf",
    "application/vnd.ms-excel",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/rtf"
  ];
}
function I() {
  return [
    ".doc",
    ".docx",
    ".pdf",
    ".rtf",
    ".txt",
    ".xls",
    ".xlsb",
    ".xlsm",
    ".xlsx"
  ];
}
function Y() {
  return [
    {
      label: "None",
      value: "",
      requireAddOnRoles: !0
    },
    {
      label: "Client management",
      value: "client_management"
    },
    {
      label: "Placement management",
      value: "placement_management"
    },
    {
      label: "Advanced placement",
      value: "advanced_placement"
    }
  ];
}
function z() {
  return [
    {
      label: "Broker management",
      value: "broker_management"
    },
    {
      label: "Insights",
      value: "insights"
    }
  ];
}
function V() {
  return [
    {
      label: "Admin",
      value: "admin"
    }
  ];
}
function q(e) {
  var t = window.analytics = window.analytics || [];
  if (!t.initialize)
    if (t.invoked)
      window.console && console.error && console.error("Segment snippet included twice.");
    else {
      t.invoked = !0, t.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"], t.factory = function(n) {
        return function() {
          const a = Array.prototype.slice.call(arguments);
          return a.unshift(n), t.push(a), t;
        };
      };
      for (let n = 0; n < t.methods.length; n += 1) {
        const a = t.methods[n];
        t[a] = t.factory(a);
      }
      t.load = function(n, a) {
        const o = document.createElement("script");
        o.type = "text/javascript", o.async = !0, o.src = `https://cdn.segment.com/analytics.js/v1/${n}/analytics.min.js`;
        const r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(o, r), t._loadOptions = a;
      }, t._writeKey = e, t.SNIPPET_VERSION = "4.15.3", t.load(e), t.page();
    }
  t.addSourceMiddleware(({ payload: n, next: a }) => {
    n.obj.type === "page" && window.sessionStorage.setItem("segmentPageMessageId", n.obj.messageId), a(n);
  });
}
function J(e = {}) {
  if (window.analytics) {
    let t;
    e.broker ? { name: t } = e.broker : e.carrier && ({ name: t } = e.carrier);
    const n = {
      ...e,
      org_name: t,
      roles: e.roles ? e.roles.map(({ name: a }) => a).join(", ") : "",
      Site: window.location.hostname.match(/^[a-z0-9]+/i)[0].toLowerCase()
    };
    window.analytics.identify(e.id, n);
  }
}
function H(e, t) {
  window.analytics && window.analytics.page(e, t);
}
function Z(e, t) {
  window.analytics && window.analytics.track(e, {
    broker_id: null,
    employer_id: null,
    project_id: null,
    project_product_id: null,
    product_type_id: null,
    product_id: null,
    carrier_id: null,
    document_id: null,
    project_products_container_id: null,
    rate_attribute_id: null,
    rate_value_id: null,
    plan_design_attribute_id: null,
    plan_design_value_id: null,
    user_broker_id: null,
    user_carrier_id: null,
    target_carrier_id: null,
    target_broker_id: null,
    target_user_id: null,
    target_email: null,
    ...t,
    page_message_id: window.sessionStorage.getItem("segmentPageMessageId")
    // add the stored "segmentPageMessageId" to each payload for every tracked event
  });
}
function X(e) {
  const t = new RegExp(/^((?=[a-z0-9-]{1,63}\.)[a-z0-9-]+(-[a-z0-9-]+)*\.)+[a-z]{2,63}$/);
  return e.match(t);
}
function G(e, t = []) {
  const n = e != null && e.includes("@") ? e.split("@")[1].toLowerCase() : null;
  return t.some((a) => a.toLowerCase() === n);
}
export {
  V as adminRoles,
  B as arrayToObject,
  z as brokerAddOnRoles,
  Y as brokerRoles,
  w as convertUTCDateToLocalDate,
  P as deleteCookie,
  T as forceRerender,
  $ as formatDateAndTime,
  x as formatNumber,
  N as formatSimpleDate,
  D as getAxiosConfig,
  _ as getCookie,
  C as getRanges,
  J as identifySegmentUser,
  q as initializeSegment,
  A as isDateValid,
  E as isStopLossProduct,
  I as reusableAcceptableUploadFileExtensions,
  U as reusableAcceptableUploadFileTypes,
  R as reusableAgeBandedValues,
  O as reusableCompoundBySubtype,
  j as reusableMonths,
  S as reusableProjectTypes,
  L as reusableRateBasisOptions,
  F as reusableSubtypeLabels,
  h as setCookie,
  M as sortObjects,
  Z as trackSegmentEvent,
  H as trackSegmentPage,
  X as validateDomain,
  G as validateEmailDomain
};
